import { render, staticRenderFns } from "./newWarehouseTypeIcon.vue?vue&type=template&id=cb1ce008&scoped=true"
import script from "./newWarehouseTypeIcon.vue?vue&type=script&lang=js"
export * from "./newWarehouseTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1ce008",
  null
  
)

export default component.exports